"use strict";

exports.__esModule = true;
exports.Enable = void 0;

var Term_1 = require("../Term");

exports.Enable = new Term_1.Term('Enable', 'ACTION', '$enable', {
  override: function override(tokens) {
    var id = tokens[1];
    return {
      collection: id.data.collection,
      id: id.value,
      property: 'active',
      value: true,
      _length: 1
    };
  }
});